const BASE_URL = process.env.REACT_APP_API_URL_DEFAULT;

export const CONSENT_URL = {
  GetStatus: `${BASE_URL}consent/status`,
  GetVersion: `${BASE_URL}consent/version`,
  SubmitConsent: `${BASE_URL}consent`,
};
